// Loader.jsx
import "./Loader.css";

export default function Loader() {
  return (
    <div className="loader-wrapper">
      <div className="loader"></div>
    </div>
  );
}
